module.exports = __webpack_public_path__ + "img/EzzeBank06.af946a7a.png";